import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: "[appTrimOnBlur]",
    standalone: true,
})
export class TrimOnBlurDirective {
    constructor(private readonly ngControl: NgControl) {}

    @HostListener("blur")
    onBlur(): void {
        const control = this.ngControl.control;
        if (!control) return;

        const value = control.value;

        if (typeof value === "string") {
            const trimmed = value.trim();

            if (trimmed !== value) {
                control.setValue(trimmed, {
                    emitEvent: false, // avoid extra valueChanges loops
                });
            }
        }
    }
}
